import React from "react";
import "./arrowDown.css";

const ArrowDownIcon = () => {
  return <span className="icon-arrow_down" />;
};

export default ArrowDownIcon;
